module.exports = __webpack_public_path__ + "static/media/monkey.24cf0452.png";